import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from '@/App'
import { startAuthListener } from '@/lib/auth'
import { configureAmplify } from '@/lib/amplify'
import { isClientError } from '@/lib/errors'
import '@fontsource-variable/atkinson-hyperlegible-next'
import '@fontsource-variable/atkinson-hyperlegible-mono'
import '@/styles/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 4xx (403, 404, 422) will not change on retry; only retry network/5xx once.
      retry: (count, error) => !isClientError(error) && count < 1,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousData,
    },
  },
})

function Bootstrap() {
  useEffect(() => {
    configureAmplify()
    return startAuthListener()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Bootstrap />
  </StrictMode>,
)
